// src/app/config/customer1.config.ts


import {CustomerConfig} from "../CustomerConfig";
// K+S
export const customer1Config: CustomerConfig = {
  icons: {
    favIcon: 'logo.png',
    icon: 'logo.png',
  },
  strings: {
    title: 'Parkticket online bezahlen | K+S Parkraumservice',
    footerText: "test",
    email: "info@parkraum.de",
    number: "+49 0341 33157290",
    contactRef: "https://www.parkraum.de/impressum/",
    dataProtectionRef: "https://www.parkraum.de/datenschutz/",
    metaDescription: "Parkticket jetzt online bezahlen mit K+S Parkraumservice – einfach, sicher & ohne Registrierung über pay.parkraum.de. Kennzeichen eingeben, Zahlung abschließen & weiterfahren.",
  }
};
